import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect } from 'react';
import utils from '../../../../utils';
import s from './index.less';
import AMapLoader from '@amap/amap-jsapi-loader';

export default function Estate(props) {
    useStyles(s);

    useEffect(() => {
        initMap();
    }, []);

    const estateInfo = props.datasouse;

    const initMap = () => {
        AMapLoader.load({
            key: '7de1cfcba9ec4a3854ae4129aafac4f7', // 申请好的Web端开发者Key，首次调用 load 时必填
            version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ['AMap.ToolBar'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            AMapUI: {
                // 是否加载 AMapUI，缺省不加载
                version: '1.1', // AMapUI 缺省 1.1
                plugins: [], // 需要加载的 AMapUI ui插件
            },
            Loca: {
                // 是否加载 Loca， 缺省不加载
                version: '1.3.2', // Loca 版本，缺省 1.3.2
            },
        })
            .then(AMap => {
                var map = new AMap.Map('container', {
                    center: [props.longitude, props.latitude], //中心点坐标
                    zoom: 14, //级别
                    resizeEnable: true,
                    scrollWheel: false,
                    isHotspot: false,
                });
                var toolBar = new AMap.ToolBar({
                    visible: true,
                    locate: false,
                });
                map.addControl(toolBar);
                let centerLabel = new AMap.Marker({
                    position: new AMap.LngLat(props.longitude, props.latitude),
                    offset: new AMap.Pixel(0, 0),
                    zIndex: 101,
                    content: `<div class="houseLabel">
                            <div class="housePoint"></div>
                            <div class="houseName">${props.mapname}<i class="arrow"></i></div>
                          </div>
                        `,
                });
                map.add(centerLabel);
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <>
            <div id={`tab${props.index}`} className="base-content xiaoqu">
                <h2>{props.title}</h2>
                <div className="main">
                    {/* <div className="info">
                        <p><span>所在城区</span>{estateInfo.countryAreaName || '暂无数据'}</p>
                        <p><span>所属商圈</span>{estateInfo.tradeAreaName || '暂无数据'}</p>
                        <p><span>建筑类型</span>{estateInfo.buildingTypeF || estateInfo.newHouseTypeF || '暂无数据'}</p>
                        {props.businesstype !== 3 ? <p><span>建筑年代</span>{estateInfo.completionYears || '暂无数据'}</p> : null}

                        {props.businesstype !== 3 ?
                            <p>
                                <span>物业费用</span>
                                {estateInfo.propertyFee ? estateInfo.propertyFee + '元/月/㎡' : '暂无数据'}
                            </p> :
                            <p>
                                <span>物业费用</span>
                                {utils.numberComparison(estateInfo.housekeeperPriceStart, estateInfo.housekeeperPriceEnd, '-', '元/月/㎡', '暂无数据')}
                            </p>
                        }

                        {props.businesstype !== 3 ?
                            <p><span>车位比例</span>{estateInfo.parkingRatio || '暂无数据'}</p> :
                            <p><span>规划车位</span>{estateInfo.planningParkingSpace || '暂无数据'}</p>}

                        {props.businesstype !== 3 ? <p><span>小区幼儿园</span>{estateInfo.kindergarten || '暂无数据'}</p> : null}

                    </div> */}
                    {props.businesstype === 3 ? (
                        <div className="info">
                            <p>
                                <span>所在城区</span>
                                {estateInfo.countryAreaName || '暂无数据'}
                            </p>
                            <p>
                                <span>所属商圈</span>
                                {estateInfo.tradeAreaName || '暂无数据'}
                            </p>
                            <p>
                                <span>建筑类型</span>
                                {estateInfo.buildingTypeF ||
                                    estateInfo.newHouseTypeF ||
                                    '暂无数据'}
                            </p>
                            <p>
                                <span>物业费用</span>
                                {utils.numberComparison(
                                    estateInfo.housekeeperPriceStart,
                                    estateInfo.housekeeperPriceEnd,
                                    '-',
                                    '元/月/㎡',
                                    '暂无数据',
                                )}
                            </p>
                            <p>
                                <span>规划车位</span>
                                {estateInfo.planningParkingSpace || '暂无数据'}
                            </p>
                        </div>
                    ) : null}

                    <div
                        className="address-container"
                        id="container"
                        style={{ height: 480 }}
                    />
                </div>
            </div>
        </>
    );
}
